module.exports = __webpack_public_path__ + "static/img/cj.0a776cdf.png";